import { useState } from 'react';
import { CustomDialog } from '@/components/dialog/v1/CustomDialog';
import { useLinkCategoryContextValueHook } from '@/views/mypage/contexts/LinkCategoryContextProvider';
import { findAlbumLayout } from './albumLayouts';
import { IMAGE_MODULE_THEMES, resolveDisplayConfig } from './imageThemes';
import { PlaceholderTile, WegetImageModuleForm } from './WegetImageModuleForm';
import { ModuleCard } from '../weget-module-card/ModuleCard';

export const IMAGE_MODULE_LABELS = { CAROUSEL: '캐러셀', ALBUM: '앨범' };

/**
 * 에디터 목록의 캐러셀·앨범 모듈 카드 (드래그·수정·숨김·삭제)
 */
export function WegetImageModuleItem({ moduleItemIndex, moduleItem, onReqDelete, onReqChangeIsHide, onReqUpdateInfo }) {
    const linkCategoryContextValueHook = useLinkCategoryContextValueHook();
    const [editOpen, setEditOpen] = useState(false);

    const images = moduleItem?.imageList || [];
    const isCarousel = moduleItem?.type === 'CAROUSEL';
    const summary = isCarousel
        ? `${images.length}장 · ${moduleItem?.carouselConfig?.ratio}`
        : `${moduleItem?.albumConfig?.count}장 · ${findAlbumLayout(moduleItem?.albumConfig?.count, moduleItem?.albumConfig?.layout)?.label}`;
    const display = resolveDisplayConfig(moduleItem);
    const themeLabel = IMAGE_MODULE_THEMES.find(t => t.value === display.theme)?.label;
    const category = linkCategoryContextValueHook?.content?.find(r => r.id === moduleItem?.linkCategoryId)?.name;

    const handleSubmit = (body) => {
        onReqUpdateInfo({ id: moduleItem?.id, ...body });
        setEditOpen(false);
    }

    return (
        <>
            <ModuleCard
                id={moduleItem.id}
                index={moduleItemIndex}
                isHide={moduleItem?.isHide}
                badgeIcon='/assets/icons/image_default_mainColor.svg'
                badgeLabel={IMAGE_MODULE_LABELS[moduleItem?.type]}
                badgeExtra={<span className="truncate text-[12px] text-gray-500">{summary} · {themeLabel}</span>}
                categoryName={category}
                onEdit={() => setEditOpen(true)}
                onToggleHide={onReqChangeIsHide}
                onDelete={onReqDelete}
            >
                <div className="min-w-0">
                    <p className="truncate text-[15px] font-bold text-gray-900">{moduleItem?.title || <span className="font-normal text-gray-400">제목 없음</span>}</p>
                    {display.showDescription && moduleItem?.description && <p className="truncate text-[12px] text-gray-500">{moduleItem.description}</p>}
                    {moduleItem?.linkUrl && <p className="truncate text-[11px] text-gray-400">바로가기 · {moduleItem.linkUrl}</p>}
                </div>
                <div className="flex gap-1.5 overflow-hidden">
                    {images.slice(0, 6).map((image, i) => (
                        image?.url
                            ? <img key={i} src={image.url} alt="" className="h-14 w-14 shrink-0 rounded-lg object-cover ring-1 ring-black/5" />
                            : <span key={i} className="relative h-14 w-14 shrink-0 overflow-hidden rounded-lg"><PlaceholderTile placeholder={image?.placeholder || 0} /></span>
                    ))}
                    {images.length > 6 && <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-xs font-semibold text-gray-500">+{images.length - 6}</span>}
                </div>
            </ModuleCard>

            {editOpen &&
                <CustomDialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth='sm'>
                    <div className="p-5">
                        <CustomDialog.Header style={{ marginBottom: '20px' }}>
                            <CustomDialog.Header.Fake />
                            <CustomDialog.Header.Title>{IMAGE_MODULE_LABELS[moduleItem?.type]} 모듈</CustomDialog.Header.Title>
                            <CustomDialog.Header.Close onClick={() => setEditOpen(false)} />
                        </CustomDialog.Header>
                        <WegetImageModuleForm type={moduleItem?.type} initial={moduleItem} submitLabel="수정" onSubmit={handleSubmit} />
                    </div>
                </CustomDialog>
            }
        </>
    );
}
